module.exports = __webpack_public_path__ + "static/media/4.eea44e94.jpg";